import { Box, Chip, Stack, Typography } from '@mui/material';

type ColorInputContentProps = {
	value: string | undefined;
};

const isHexColor = (value: string) => /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value);

export default function ColorInputContent({ value }: ColorInputContentProps) {
	if (!value) {
		return null;
	}

	return (
		<Stack direction="row" spacing={1} alignItems="center" sx={{ minHeight: 24 }}>
			{isHexColor(value) && (
				<Box
					sx={{
						width: 16,
						height: 16,
						borderRadius: 0.5,
						border: '1px solid',
						borderColor: 'divider',
						backgroundColor: value,
					}}
				/>
			)}
			<Chip label={value} size="small" variant="outlined" color="primary" sx={{ maxWidth: '100%' }} />
			<Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
				Color
			</Typography>
		</Stack>
	);
}
